import { Container, Grid, Card, CardContent, Typography, useMediaQuery } from '@mui/material';

import laboratorio from "../../../assets/images/rede-atendimento/laboratorios-especializados.jpg";
import emergencia from "../../../assets/images/rede-atendimento/hospitais-referencia.jpg";
import clinica from "../../../assets/images/rede-atendimento/clinicas-especializadas.jpg";

const CredenciadaSection = () => {

  const isMobile = useMediaQuery("(max-width:768px)");
  
  return (
    <Container maxWidth="lg" style={{ padding: '1em' }}>
      <Typography variant={ isMobile ? "h6" : "h5"} gutterBottom>Rede de Atendimento Ampla e Qualificada</Typography>
      <Typography variant="body1" color="textSecondary" paragraph textAlign="justify">
        O Innova Plano de Saúde conta com uma extensa rede credenciada, distribuída para atender você onde estiver.
      </Typography>
      <Grid container spacing={4}>
        {/* Card 1 - Hospitais */}
        <Grid item xs={12} sm={6} md={4} >
          <Card>
            <CardContent  style={
              {
                backgroundImage: `url(${emergencia})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "center",
                aspectRatio: "4/3"
              }
            }>
              {/* <Typography variant="h6" style={styleText}>Hospitais de Referência</Typography> */}
              {/* <Typography variant="body2" style={styleText}>Cuidados especializados para situações de emergência.</Typography> */}
            </CardContent>
          </Card>
        </Grid>
        {/* Card 2 - Clínicas */}
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent style={
              {
                backgroundImage: `url(${clinica})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                aspectRatio: "4/3"
              }
            }>
              {/* <Typography variant="h6" style={styleText}>Clínicas Especializadas</Typography> */}
              {/* <Typography variant="body2" style={styleText}>Cuidado abrangente e personalizado para cada necessidade.</Typography> */}
            </CardContent>
          </Card>
        </Grid>
        {/* Card 3 - Laboratórios */}
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent style={
              {
                backgroundImage: `url(${laboratorio})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                aspectRatio: "4/3"
              }
            }>
              {/* <Typography variant="h6" style={styleText}>Laboratórios</Typography> */}
              {/* <Typography variant="body2" style={styleText}>Diagnósticos precisos com tecnologia avançada.</Typography> */}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default CredenciadaSection;
